import { createAction } from "@reduxjs/toolkit";
import { REDUCER_PREFIX } from "./slice";

export const getCountriesRequest = createAction(
    `${REDUCER_PREFIX}/getCountriesRequest`
);
